import { render } from "./NavbarTopProfileDropdown.vue?vue&type=template&id=4d12d57d"
import script from "./NavbarTopProfileDropdown.vue?vue&type=script&lang=ts"
export * from "./NavbarTopProfileDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script